import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [
      { name: getFieldLabel() },
      { name: "ID(사번)" },
      { name: "부서" },
      { name: "구분" },
      { name: "직종" },
      // { name: "직급" },
      { name: "성명" },
      // { name: "최종 입사일" },
      // { name: "현보직일" },
      { name: "연락처" },
      { name: "총 교육이수 시간" },
      // { name: "퇴임일" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: {
          // 학교(기관)명
          const fieldNames = !func.getContent(value).fieldNames ? func.getContent(value).field_names : func.getContent(value).fieldNames;
          if (fieldNames && fieldNames.length === 1) {
            return fieldNames.join(", ");
          } else if (fieldNames && fieldNames.length > 1) {
            // 만약 두번째 아이템이 4글자 이하면 첫번째와 두번째 아이템을 쉼표로 붙여서 반환한다
            if (fieldNames[1].length <= 4) {
              return `${fieldNames[0]}, ${fieldNames[1]}`;
            } else {
              return `${fieldNames[0]}, ${fieldNames[1].substring(0, 4)}...`;
            }
          } else {
            return "-";
          }
        }
        case 1:
          return func.getContent(value).employee_id !== "undefined" ? func.getContent(value).employee_id : ""; // 사번
        case 2:
          return func.getContent(value).targetCompany; // 부서
        case 3:
          return func.getContent(value).job_category; // 구분
        case 4:
          return func.getContent(value).employment_type; // 직종
        // case 5:
        // return func.getContent(value).job_title; // 직급
        case 5:
          return func.getContent(value).enc.full_name; // 성명
        // case 7:
        //   return func.getContent(value).hire_date; // 최종 입사일
        // case 7:
        // return func.getContent(value).current_position_date; // 현보직일
        case 6:
          return func.getContent(value).enc.contact_number; // 연락처
        case 7: {
          // 총 교육이수 시간
          if (typeof value.total_education_hours === "undefined") return "0시간 0분";
          const totalEducationHours = value.total_education_hours;

          // "H시간 M분" 형식으로 변환한다.
          // 데이터는 3.5 와 같은 형식으로 저장되어 있으며 "3시간 30분" 으로 변환되야 한다.
          const hours = Math.floor(totalEducationHours);
          const minutes = Math.round((totalEducationHours - hours) * 60);
          return `${hours}시간 ${minutes}분`;
        }
        // case 11:
        //   return func.getContent(value).retirement_date; // 퇴임일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { fieldName: nav.value.fieldName, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword, fieldId: nav.value.fieldId };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];
    if (nav.value.fieldName) {
      returnData.push("content$body.field_names*%[:default_field_name]%");
    }
    if (nav.value.fieldId) {
      returnData.push(`content$body.fields*%[:field_id]%`);
    }

    switch (nav.value.searchType) {
      case getFieldLabel():
        returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
        break;
      case "ID(사번)":
        returnData.push("content$body.employee_id*%[:default_skw]%");
        break;
      case "부서":
        returnData.push("content$body.targetCompany*%[:default_skw]%");
        break;
      case "구분":
        returnData.push("content$body.job_category*%[:default_skw]%");
        break;
      case "직종":
        returnData.push("content$body.employment_type*%[:default_skw]%");
        break;
      case "직급":
        returnData.push("content$body.job_title*%[:default_skw]%");
        break;
      case "성명":
        returnData.push("content$body.enc.full_name*%[:default_skw]%");
        break;
      case "최종 입사일":
        returnData.push("content$body.hire_date*%[:default_skw]%");
        break;
      case "현보직일":
        returnData.push("content$body.current_position_date*%[:default_skw]%");
        break;
      case "연락처":
        returnData.push("content$body.contact_number*%[:default_skw]%");
        break;
      case "총 교육이수 시간":
        returnData.push("content$body.inputC_2*%[:default_skw]%");
        break;
      case "퇴임일":
        returnData.push("content$body.retirement_date*%[:default_skw]%");
        break;
    }
    return returnData;
  },
};
